import { AlertMessage, MUIIcon, Spinner } from "../../../../widgets"
import { FC, useState } from "react"
import { IPaymentButtonProps } from "../IPaymentButtonProps"
import { PageLinkHelper } from "../../../../base/helpers"
import clsx from "clsx"
import { getButtonClass } from "../../buttons/helper"
import { toAbsoluteUrl } from "../../../../../helpers"
import { useAuth } from "../../../../../modules/auth"
import { submitForm } from "../../../helpers/submit-form"

export const HdfcButton: FC<IPaymentButtonProps> = ({
    orderNo, enrolmentNo, entity, entityId,
    currency, amount,
    firstName, email, phoneNumber,
    successPage, failedPage,
    disabled, tooltip, style, size, icon, label,
    className, children
}) => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
    const [error, setError] = useState<string>()
    const { siteId, user } = useAuth()

    const handleOnClick = () => {
        if (!siteId || !user || !amount || !successPage || !failedPage) {
            setError("Missing required fields. Please check your input.");
            return;
        }

        setIsSubmitting(true)
        setError('')

        const successPageUrl = PageLinkHelper.getPageLinkUrl(siteId, successPage);
        const failedPageUrl = PageLinkHelper.getPageLinkUrl(siteId, failedPage);
        const params = {
            enrolmentNo: enrolmentNo || '',
            orderNo: orderNo || '',
            entity: entity || '',
            entityId: entityId || '',
            currency: currency || "INR",
            amount: amount || 0,
            name: firstName || '',
            email: email || '',
            phoneNumber: phoneNumber || '9999999999',
            successPageUrl: successPageUrl || '',
            failedPageUrl: failedPageUrl || '',
        } as any

        submitForm("/api/Payments/Hdfc", params, "POST")
    };

    return (
        <>
            <button
                disabled={disabled || isSubmitting || !user || !amount}
                type="button"
                title={tooltip}
                onClick={handleOnClick}
                className={clsx(getButtonClass(style, size, "btn-secondary"), className)}
            >
                <Spinner show={isSubmitting} className="me-1" />
                <img
                    alt="Flywire logo"
                    className="h-25px"
                    src={toAbsoluteUrl('/media/logos/HDFClogo.png')}
                />
                {(!isSubmitting && icon) && <MUIIcon iconName={icon} className={clsx({ "me-1": !!label })} />}
                {label && <span>{label}</span>}
                {children}
            </button>
            <AlertMessage type="Error" show={!!error} message={error} />
        </>
    )
}